<div class="modal-header">
  <h5 class="modal-title">Attention, vous allez supprimer ce calcul</h5>
</div>
<div class="modal-body">
  <p>Voulez-vous vraiment supprimer? Vous allez perdre toutes les informations relatives a ce calcul</p>
</div>
<div class="modal-footer">
  <button (click)="activeModal.close(false)" class="btn btn-seconday" data-bs-dismiss="modal" type="button">Non</button>
  <button (click)="activeModal.close(true)" class="btn btn-danger" type="button">Oui je veux supprimer ce calcul
  </button>
</div>
